import React from 'react'

const About = () => {
  return (
    <div className='text-white max-w-[1200px] mx-auto mt-0 mb-0' id='about'>
        <div className='sm:py-16 mt-4 md:mt-0 text-left flex'>
                <div className='my-auto mx-6'>
                    <h2 className='text-4xl font-bold mb-6 primary-color'>About Me</h2>
                    {/* <p className='text-base lg:text-lg'>
                    Hi, I'm Moeez, a Computer Science student at McMaster University, 
                    specializing in full-stack development, machine learning, and web technologies. 
                    From a young age, I've been fascinated by technology's potential to improve lives. 
                    I've worked on projects like GoPic, a travel and social media app, and MedTrack, a 
                    medication scheduling app. I'm passionate about both the technical and creative 
                    aspects of software engineering, always seeking opportunities to learn through 
                    hackathons, projects, and coursework. With a strong foundation in JavaScript, 
                    React, and Python, I'm eager to apply my skills to real-world challenges and 
                    contribute to mission-driven teams in the tech world.
                    </p> */}

                    <p className='text-lg leading-relaxed '>
                      <strong>👋 Hi, I'm Moeez!</strong><br></br>
                      I'm a Computer Science student at McMaster University with an insatiable curiosity for full-stack development, machine learning, and web technologies. I thrive on solving complex problems, crafting intuitive user experiences, and exploring how technology can shape a better tomorrow.
                      <br></br> <br></br>
                      <strong>💡 What drives me:</strong><br></br>
                      Ever since I wrote my first lines of code, I've been captivated by technology's power to transform ideas into impactful solutions. Whether it's building apps to connect people or designing systems to streamline everyday tasks, I'm driven by a deep passion for combining creativity with technical know-how.
                      <br></br><br></br>
                      <strong>🎯 What I'm looking for:</strong><br></br>
                      I'm eager to take on real-world challenges where I can push my boundaries, grow alongside talented teams, and make a meaningful impact. Whether it's through projects, hackathons, or internships, I'm always on the lookout for opportunities to turn ambitious ideas into reality.
                    </p>
                </div>

        </div>
    </div>
  )
}

export default About